import _ from 'lodash';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import sphereLogo from '../../images/logos/sphere_logo_bw.svg';
//import chevnwImg from '../../images/samples/CHEVNW.jpg';
//import sampleImg from '../../images/samples/1877532.jpg';

//import WarningIcon from "@material-ui/icons/Warning";

const iw = 1088;
const ih = 1472;

const p = (v) => {
	return `${v * 100}%`;
};
const pw = (v) => {
	return `${(v / iw) * 100}%`;
};
const ph = (v) => {
	return `${(v / ih) * 100}%`;
};

const toNum = (v) => {
	return _.isNumber(v) ? v.toLocaleString('en-US') : '';
};
const styles = () => {
	//const fw = 1280;
	//const fh = 1664;
	return {
		root: {
			//position : 'absolute',
			backgroundColor: 'white',
			height: '100%',
			width: '100%',
			padding: `${p(0.029)} ${p(0.04)} 0 ${p(0.035)}`,
			boxSizing: 'border-box',
			fontFamily: 'Roboto',
			fontWeight: 500,
			fontSize: '1.7vw',
			letterSpacing: '-0.01vw',
		},
		aspectRatio: {
			//position: 'fixed',
			width: '100%',
			//paddingBottom: '129.411%',
			paddingBottom: '135%',
			top: 0,
			left: 0,
			position: 'relative',
		},
		pageBackground: {
			position: 'fixed',
			width: '100%',
			height: '100%',
			//background: 'white',
			top: 0,
			left: 0,
		},
		barcodeContainer: {
			position: 'absolute',
			top: 0,
			left: pw(421),
		},
		barcode: {
			fontFamily: "'Barcode'",
			fontSize: '5.9vw',
			letterSpacing: '-0.000vw',
		},
		inner: {
			position: 'absolute',
			height: '100%',
			width: '100%',
			zIndex: 5,
			//border : '1px solid red',
		},
		logoContainer: {
			position: 'absolute',
			top: '6.9%',
			left: '44.5%',
			textAlign: 'center',
		},
		logo: {
			width: '9vw',
			//height: p(0.),
		},

		gridTable: {
			margin: 0,
			padding: 0,
			borderCollapse: 'collapse',
			width: '100%',
			fontSize: '1.5vw',
			lineHeight: 1.2,
			borderSpacing: 0,
		},
		rowLabel: {
			margin: 0,
			padding: 0,
			border: '.2vw solid black',
			textAlign: 'center',
		},
		rowLabel2: {
			margin: 0,
			padding: 0,
			border: '.2vw solid black',
			textAlign: 'left',
			paddingLeft: '1%',
			fontSize: '1.3vw',
			whiteSpace: 'nowrap',
			width: '33%',
			lineHeight: 1.3,
		},
		rowValue: {
			margin: 0,
			padding: 0,
			border: '.2vw solid black',
			textAlign: 'left',
			width: '61.5%',
			paddingLeft: '2%',
		},
		rowTr: {
			margin: 0,
			padding: 0,
		},
		rowHeader: {
			margin: 0,
			padding: 0,
			border: '.2vw solid black',
			textAlign: 'left',
			paddingLeft: '1%',
			fontSize: '1.3vw',
			whiteSpace: 'nowrap',
			lineHeight: 1.3,
			backgroundColor: '#ddd',
			height: '2.2vw',
		},
		tankRowHeader: {
			margin: 0,
			padding: 0,
			border: '.2vw solid black',
			textAlign: 'center',
			paddingLeft: '1%',
			fontSize: '1.3vw',
			whiteSpace: 'nowrap',
			lineHeight: 2.2,
			backgroundColor: '#ddd',
			height: '2.2vw',
		},

		tankRow: {
			margin: 0,
			padding: 0,
			border: '.2vw solid black',
			textAlign: 'left',
			paddingLeft: '.2%',
			paddingRight: '.5%',
			lineHeight: 1.7,
			whiteSpace: 'nowrap',
		},

		comRow: {
			margin: 0,
			padding: 0,
			border: '.2vw solid black',
			textAlign: 'left',
			paddingLeft: '.2%',
			paddingRight: '.5%',
			lineHeight: 1.9,
		},

		fillOutRow: {
			margin: 0,
			padding: 0,
			border: '.2vw solid black',
			paddingLeft: '.2%',
			paddingRight: '.5%',
			whiteSpace: 'nowrap',
			//textAlign: 'right',
		},

		compartmentTable: {
			margin: 0,
			padding: 0,
			borderCollapse: 'collapse',
			width: '100%',
			lineHeight: 2,
			borderSpacing: 0,
			fontSize: '1.4vw',
		},

		bottomTable: {
			margin: 0,
			padding: 0,
			borderCollapse: 'collapse',
			width: '100%',
			fontSize: '1.5vw',
			lineHeight: 1.9,
			borderSpacing: 0,
		},
	};
};

class DeliveryTicket extends Component {
	render() {
		const { classes, deliveryTicket } = this.props;

		if (!deliveryTicket) {
			return <div>Fetching delivery ticket</div>;
		}

		const { tmwOrderId, deliveryEarliestDate, deliveryLatestDate, shiftDate } = deliveryTicket;
		const formattedDate = moment(shiftDate).format('MMMM DD, YYYY');
		const startTime = moment(deliveryEarliestDate).format('HH:00');
		const endTime = moment(deliveryLatestDate).format('HH:00');

		return (
			<div className={classes.root}>
				{/*}
				<img
					alt="chev"
					src={sampleImg}
					style={{
						position: 'absolute',
						width: '100%',
						zIndex: 4,
						left: 0,
						top: 0,
						opacity: 0.4,
					}}
				/>
				*/}
				<div className={classes.aspectRatio}>
					<div className={classes.inner}>
						<div className={classes.logoContainer}>
							<img alt="Logo" className={classes.logo} src={sphereLogo} />
						</div>
						<div style={{ paddingTop: ph(8), lineHeight: 1.1 }}>
							{this.renderAddress({ revType1: deliveryTicket.revType1 })}
							<div style={{ marginTop: '.9%' }}>
								<div>
									<strong>Shift</strong>&nbsp;&nbsp;AM
								</div>
								<div>
									<strong>Loading Facility</strong>
									<br />
									{deliveryTicket.loadingFacilityName}
									<br />
									{deliveryTicket.loadingFacilityAddress} - {deliveryTicket.loadingFacilityCity},{' '}
									{deliveryTicket.loadingFacilityState}
									<br />
								</div>
								<div style={{ marginTop: '.5%', maxWidth: '27%' }}>
									<strong>Delivery Site</strong>
									<br />
									{deliveryTicket.deliverySiteName}
									<br />
									{deliveryTicket.deliverySiteAddress}
									{deliveryTicket.deliverySiteLoadingNumber && (
										<>
											<br />
											{deliveryTicket.deliverySiteLoadingNumber}
										</>
									)}
									<br />
									{deliveryTicket.deliverySiteCity}, {deliveryTicket.deliverySiteState}{' '}
									{deliveryTicket.deliverySiteZip}
								</div>
							</div>
						</div>
						<div className={classes.barcodeContainer}>
							<div className={classes.barcode}>*{deliveryTicket.tmwOrderId}*</div>
							<div style={{ marginTop: '6%', fontSize: '1.5vw', fontWeight: 'bold' }}>
								DELIVERY TICKET #&nbsp;&nbsp;&nbsp;{deliveryTicket.tmwOrderId}
							</div>
						</div>

						<div
							style={{
								position: 'absolute',
								right: ph(0),
								width: '30.7%',
								top: '0',
							}}
						>
							<div>
								<span>DRIVER</span>
								<span>:</span> <span>{deliveryTicket.driverFullName}</span>
							</div>
							<table
								className={classes.gridTable}
								style={{
									marginTop: '2.1%',
								}}
							>
								<tbody>
									<tr className={classes.rowTr}>
										<td className={classes.rowLabel}>DELIVERY</td>
										<td className={classes.rowValue}>{formattedDate}</td>
									</tr>
									<tr>
										<td className={classes.rowLabel}>TICKET #</td>
										<td className={classes.rowValue}>{tmwOrderId}</td>
									</tr>
									<tr>
										<td className={classes.rowLabel}>LOAD #</td>
										<td className={classes.rowValue}>{deliveryTicket.tripNumber}</td>
									</tr>
									<tr>
										<td className={classes.rowLabel}>TRK/TRLR</td>
										<td className={classes.rowValue}>{deliveryTicket.truckTrailerNumber}</td>
									</tr>
									<tr>
										<td className={classes.rowLabel} colSpan="2">
											ODOMETER READING
										</td>
									</tr>
									<tr>
										<td className={classes.rowLabel}>START</td>
										<td className={classes.rowValue}></td>
									</tr>
									<tr>
										<td className={classes.rowLabel}>FINISH</td>
										<td className={classes.rowValue}></td>
									</tr>
									<tr>
										<td className={classes.rowLabel}>TOTAL TRIP</td>
										<td className={classes.rowValue}></td>
									</tr>
								</tbody>
							</table>
						</div>

						<div
							style={{
								position: 'absolute',
								right: ph(0),
								width: '72.7%',
								top: '15.8%',
							}}
						>
							<div style={{ display: 'flex', width: '100%' }}>
								<div style={{ width: '36.5%', marginRight: '1%' }}>
									<table className={classes.gridTable} style={{ lineHeight: 1.1 }}>
										<tbody>
											<tr className={classes.rowTr}>
												<td className={classes.rowLabel2}>Del Time</td>
												<td className={classes.rowValue}>
													{startTime} - {endTime}
												</td>
											</tr>
											<tr className={classes.rowTr}>
												<td className={classes.rowLabel2}>Ord #</td>
												<td className={classes.rowValue}>{deliveryTicket.orderRefNumber}</td>
											</tr>
											<tr className={classes.rowTr}>
												<td className={classes.rowLabel2}>PO #</td>
												<td className={classes.rowValue}></td>
											</tr>
											<tr className={classes.rowTr}>
												<td className={classes.rowLabel2}>Avg Del Time</td>
												<td className={classes.rowValue}></td>
											</tr>
										</tbody>
									</table>
								</div>
								<div
									style={{
										flex: 1,
										fontSize: '1.5vw',
										padding: '.2%',
									}}
								>
									<div
										style={{
											flex: 1,
											backgroundColor: '#555',
											color: 'white',
											textAlign: 'center',
											fontSize: '1.4vw',
											padding: '.2%',
											//height: '10%',
										}}
									>
										Order Remarks
									</div>
									<div style={{ marginTop: '.5%' }}>{deliveryTicket.orderRemark}</div>
								</div>
							</div>
						</div>
						<div
							style={{
								position: 'absolute',
								left: 0,
								top: '20.5%',
								width: '100%',
							}}
						>
							{this.renderShipperSection({ deliveryTicket })}
							{this.renderCommodities({ deliveryTicket })}
							{this.renderTanks({ deliveryTicket })}
						</div>
						{this.renderBottomSection()}
					</div>
				</div>
			</div>
		);
	}

	renderAddress({ revType1 }) {
		if (revType1 === 'STLNW') {
			return (
				<div style={{ lineHeight: 1.1 }}>
					SUPERIOR TANK LINES
					<br />
					NW
					<br />
					3250 NW ST HELENS RD
					<br />
					PORTLAND, OR 97210
					<br />
					OFFICE 909-430-0855
					<br />
				</div>
			);
		} else if (revType1 === 'STLSW') {
			return (
				<div style={{ lineHeight: 1.1 }}>
					SUPERIOR TANK LINES
					<br />
					601 S HUNTS LANE
					<br />
					COLTON, CA 92324
					<br />
					OFFICE 909-430-0855
					<br />
					FAX 909-430-0858
					<br />
				</div>
			);
		} else {
			return (
				<div style={{ lineHeight: 1.1 }}>
					UNKNOWN REGION
					<br />
					REVTYPE1:{revType1}
				</div>
			);
		}
	}

	renderShipperSection({ deliveryTicket }) {
		return (
			<div style={{ marginTop: '5%' }}>
				<strong>Shipper/Bill To</strong>
				<div style={{ paddingLeft: '3.5%' }}>
					{deliveryTicket.billToCompanyName}, {deliveryTicket.billToCity}
				</div>
				<div
					style={{
						border: '.2vw solid black',
						height: '8.5vw',
						marginTop: '.5%',
						padding: '.3%',
						paddingTop: '.05%',
						lineHeight: 1.15,
						fontSize: '1.5vw',
						whiteSpace: 'pre-wrap',
					}}
				>
					{!_.isEmpty(deliveryTicket.shipperNotes) && <span>Shipper Notes: </span>}
					{deliveryTicket.shipperNotes.map((note, i) => {
						return (
							<span key={`shipperNote${i}`}>
								{note}
								<br />
							</span>
						);
					})}

					{!_.isEmpty(deliveryTicket.consigneeNotes) && <span>Consignee Notes: </span>}
					{deliveryTicket.consigneeNotes.map((note, i) => {
						return (
							<span key={`consigneeNote${i}`}>
								{note}
								<br />
							</span>
						);
					})}
				</div>
			</div>
		);
	}

	renderCommodities({ deliveryTicket }) {
		const { classes } = this.props;
		return (
			<div style={{ marginTop: '1%' }}>
				<table className={classes.gridTable}>
					<tbody>
						<tr className={classes.rowTr}>
							<td className={classes.rowHeader} style={{ width: '37%' }}>
								Product
							</td>
							<td className={classes.rowHeader} style={{ width: '16%' }}>
								Pin
							</td>
							<td className={classes.rowHeader} style={{ width: '8.5%' }}>
								Ordered
							</td>
							<td className={classes.rowHeader} style={{ width: '8.5%' }}>
								Gross
							</td>
							<td className={classes.rowHeader} style={{ width: '8.3%' }}>
								Net
							</td>
							<td className={classes.rowHeader}>BoL Number</td>
						</tr>
						{deliveryTicket.commodities.map((com, i) => {
							const vol = com.freightOrderedVolume;
							return (
								<tr key={i}>
									<td className={classes.comRow}>{com.cmdName}</td>
									<td className={classes.comRow}>{com.pin}</td>
									<td className={classes.comRow} style={{ textAlign: 'right' }}>
										{toNum(vol)}
									</td>
									<td className={classes.comRow}></td>
									<td className={classes.comRow}></td>
									<td className={classes.comRow}></td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		);
	}
	renderTanks({ deliveryTicket }) {
		const { classes } = this.props;
		return (
			<div style={{ marginTop: '.5%' }}>
				<table className={classes.gridTable}>
					<tbody>
						<tr className={classes.rowTr}>
							<td className={classes.tankRowHeader} style={{ width: '37%' }} colSpan="4">
								SAFE DISCHARGE RECORD
							</td>
							<td
								className={classes.tankRowHeader}
								style={{ width: '34.5%', background: 'white' }}
								colSpan="4"
							>
								Before
							</td>
							<td className={classes.tankRowHeader} style={{ background: 'white' }} colSpan="3">
								After
							</td>
						</tr>
						<tr className={classes.rowTr}>
							<td className={classes.tankRow} colSpan="2" style={{ width: '20.5%' }}>
								Product
							</td>
							<td className={classes.tankRow}>Size</td>
							<td className={classes.tankRow}>Safe Fill</td>
							<td className={classes.tankRow}>Inches</td>
							<td className={classes.tankRow}>Gallons</td>
							<td className={classes.tankRow} style={{ width: '10%' }}>
								Will Hold
							</td>
							<td className={classes.tankRow}>Water</td>
							<td className={classes.tankRow}>Inches</td>
							<td className={classes.tankRow} style={{ width: '10%' }}>
								Gallons
							</td>
							<td className={classes.tankRow}>Gals Deliverd</td>
						</tr>
						{deliveryTicket.consigneeTanks.map((tank, i) => {
							const { tankSize, ullage, cmdCode } = tank;
							return (
								<tr key={i} className={classes.rowTr}>
									<td className={classes.tankRow} style={{ width: '4%', textAlign: 'right' }}>
										{i + 1}
									</td>
									<td className={classes.tankRow}>{cmdCode}</td>
									<td className={classes.tankRow} style={{ textAlign: 'right' }}>
										{toNum(tankSize)}
									</td>
									<td className={classes.tankRow} style={{ textAlign: 'right' }}>
										{toNum(ullage)}
									</td>
									<td className={classes.tankRow}></td>
									<td className={classes.tankRow}></td>
									<td className={classes.tankRow}></td>
									<td className={classes.tankRow}></td>
									<td className={classes.tankRow}></td>
									<td className={classes.tankRow}></td>
									<td className={classes.tankRow}></td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		);
	}

	renderBottomSection() {
		const { classes } = this.props;
		return (
			<div style={{ marginTop: '.5%', position: 'absolute', bottom: '1%', width: '100%' }}>
				<table
					className={classes.compartmentTable}
					style={{
						textTransform: 'uppercase',
						textAlign: 'center',
						lineHeight: 1.3,
					}}
				>
					<tbody>
						<tr className={classes.rowTr}>
							<td className={classes.fillOutRow} colSpan="3">
								Loading Information
							</td>
							<td className={classes.fillOutRow} colSpan="3">
								Unloading Information
							</td>
						</tr>
						<tr className={classes.rowTr}>
							<td className={classes.fillOutRow}>Arrive</td>
							<td className={classes.fillOutRow}>Start</td>
							<td className={classes.fillOutRow}>Finish</td>
							<td className={classes.fillOutRow}>Arrive</td>
							<td className={classes.fillOutRow}>Start</td>
							<td className={classes.fillOutRow}>Finish</td>
						</tr>
						<tr className={classes.rowTr}>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								1
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								1
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								1
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								1
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								1
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								1
							</td>
						</tr>
						<tr className={classes.rowTr}>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								2
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								2
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								2
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								2
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								2
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'right' }}>
								2
							</td>
						</tr>

						<tr className={classes.rowTr}>
							<td className={classes.fillOutRow} colSpan="3">
								List all loading delays over 30 minutes
							</td>
							<td className={classes.fillOutRow} colSpan="3">
								List all unloading delays over 30 minutes
							</td>
						</tr>
						<tr className={classes.rowTr}>
							<td className={classes.fillOutRow} colSpan="3">
								&nbsp;
							</td>
							<td className={classes.fillOutRow} colSpan="3">
								&nbsp;
							</td>
						</tr>
						<tr className={classes.rowTr}>
							<td className={classes.fillOutRow} colSpan="3">
								&nbsp;
							</td>
							<td className={classes.fillOutRow} colSpan="3">
								&nbsp;
							</td>
						</tr>
						<tr className={classes.rowTr}>
							<td
								className={classes.fillOutRow}
								colSpan="3"
								style={{ textTransform: 'none', border: '0' }}
							>
								&lt;&lt;&lt;Trailer
							</td>
							<td
								className={classes.fillOutRow}
								colSpan="3"
								style={{ textTransform: 'none', border: '0', textAlign: 'right' }}
							>
								Tractor &gt;&gt;&gt;
							</td>
						</tr>
					</tbody>
				</table>

				<table className={classes.compartmentTable} style={{ marginBottom: '3%' }}>
					<tbody>
						<tr className={classes.rowTr} style={{ lineHeight: 1.1 }}>
							<td style={{ textAlign: 'right', width: '26%' }} colSpan={2}>
								Compartment #
							</td>
							<td style={{ textAlign: 'center' }}>5</td>
							<td style={{ textAlign: 'center' }}>4</td>
							<td style={{ textAlign: 'center' }}>3</td>
							<td style={{ textAlign: 'center' }}>2</td>
							<td style={{ textAlign: 'center' }}>1</td>
						</tr>

						<tr className={classes.rowTr}>
							<td
								className={classes.fillOutRow}
								style={{ borderLeft: 0, borderTop: 0, textAlign: 'center', lineHeight: 1 }}
							>
								Superior Tank Lines
								<br />
								Cargo Tank
							</td>
							<td className={classes.fillOutRow} style={{ textAlign: 'center', lineHeight: 1 }}>
								Gallons to
								<br />
								be loaded
							</td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
						</tr>
						<tr className={classes.rowTr}>
							<td
								className={classes.fillOutRow}
								style={{ borderLeft: 0, width: '20%', textAlign: 'right' }}
								colSpan={2}
							>
								Product type to be loaded
							</td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
						</tr>
						<tr className={classes.rowTr}>
							<td
								className={classes.fillOutRow}
								style={{ borderLeft: 0, textAlign: 'right' }}
								colSpan={2}
							>
								Riser #, Loading arm #
							</td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
						</tr>
					</tbody>
				</table>

				<table className={classes.bottomTable} style={{ textTransform: 'uppercase' }}>
					<tbody>
						<tr className={classes.rowTr}>
							<td
								className={classes.fillOutRow}
								style={{ borderLeft: 0, borderTop: 0, width: '26%', textAlign: 'right' }}
							>
								Customer Tanks
							</td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
						</tr>
						<tr className={classes.rowTr}>
							<td className={classes.fillOutRow} style={{ borderLeft: 0, textAlign: 'right' }}>
								90% Ullage
							</td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
						</tr>
						<tr className={classes.rowTr}>
							<td
								className={classes.fillOutRow}
								style={{ borderLeft: 0, borderBottom: 0, textAlign: 'right' }}
							>
								GALLONS TO BE UNLOADED
							</td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
							<td className={classes.fillOutRow}></td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	}
}

DeliveryTicket.propTypes = {
	classes: PropTypes.object.isRequired,
	deliveryTicket: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles)])(DeliveryTicket);
